export default __webpack_public_path__ + "static/media/wfn-nextgen.96b52128.png";